// import type { ICurrentUserMetadata } from "./participant";
// import type { IRoomMetadata } from "./room";

export enum HostActions {
  user_metadata = "user_metadata",
  user_data = "user_data",
  room_metadata = "room_metadata",
  request_data = "request_data", // Action to request data from Project A
}
export interface HostMessageEvent<T> {
  action: HostActions;
  data: T;
}
export interface UserData {
  name: string;
  userId: string;
  sid: string;
  isRecorder: boolean;
}
export type HostMessage<T = any> = MessageEvent<HostMessageEvent<T>>;

/// events for the parent
// type UserDataMessage = HostMessage<UserData>;
// type RoomMetadataMessage = HostMessage<IRoomMetadata>;
// type UserMetadataMessage = HostMessage<ICurrentUserMetadata>;
